<template>
  <slot v-if="type === 'luxury'" name="luxury">
    <img :src="luxuryIcon" alt="" />
  </slot>
  <slot v-if="type === 'virtuoso'" name="virtuoso">
    <img :src="virtuosoIcon" alt="" />
  </slot>
</template>

<script setup>
import { computed } from "vue";

import defaultLuxuryIcon from "@/assets/images/benefit/H_rate_icon.png";
import defaultVirtuosoIcon from "@/assets/images/benefit/virtuoso_rate_icon.png";

const props = defineProps({
  type: {
    type: String
  },
  icons: {
    type: Object,
    default: () => ({})
  }
});

const luxuryIcon = computed(() => props.icons?.luxury || defaultLuxuryIcon);
const virtuosoIcon = computed(
  () => props.icons?.virtuoso || defaultVirtuosoIcon
);
</script>

<style lang="scss" scoped>
img {
  width: 24px;
  margin-bottom: 8px;
}
</style>
